import {Component, Prop, Vue} from 'vue-property-decorator';
import List from '@/assets/common/List/List.vue';
import MachineDetail from '@/components/Machines/MachineDetail/MachineDetail.vue';
import { Machine } from '@/types';
import { LoginUser } from "@/types/Component";
import store from '@/assets/common/store/store';


@Component({
    components: {
        MachineDetail,
        List
    }
})
export default class Machines extends Vue {
    private baseUrl = '/machines';
    private title = '機械';
    private machines: Machine[] = [];
    private withHidden = false;
    private selectedMachineId = '';
    private isLoading = true;


    @Prop()
    private id!: string;

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    private created() {
      if(this.id) {
            this.selectedMachineId = this.id;
      }
      this.getMachines();
    }

    private checkboxChanged(value: boolean) {
        this.withHidden = value;
        this.getMachines();
    }

    private getMachines() {
        this.isLoading = true;
        this.$apiClient.doRequest('get', `${this.baseUrl}/?with_hidden=${this.withHidden}`).then((ret) => {
            this.isLoading = false;
            this.machines = ret.machines;
        });
    }

    private resetMachine(machineId: string){
        this.getMachines()
        this.setMachine(machineId)
    }

    private setMachine(machineId: string) {
        this.$router.push( `/master/machines/${machineId}`, () => {return});
        if(store.getters.isInputChanged==false){
        this.selectedMachineId = machineId;
        }
    }

    private createMachine() {
        this.$router.push( `/master/machines`, () => {return});
        if(store.getters.isInputChanged==false){
        this.selectedMachineId = 'create';
        }
    }

}